import { render } from "./AdminInquiriesView.vue?vue&type=template&id=2a599cc6&scoped=true"
import script from "./AdminInquiriesView.vue?vue&type=script&lang=js"
export * from "./AdminInquiriesView.vue?vue&type=script&lang=js"

import "./AdminInquiriesView.vue?vue&type=style&index=0&id=2a599cc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a599cc6"]])

export default __exports__